module.exports = __webpack_public_path__ + "static/img/gold.db468eb1.png";